exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PreviewDropzone__imgUrl__2ox09Y {\n  font-size: 10px;\n  margin: 10px 0;\n  padding: 10px;\n  text-align: center;\n  background-color: #e8e8e8;\n  border-radius: 3px;\n  border: dotted 3px #d3d3d3;\n  color: #4a4a4a;\n}\n.PreviewDropzone__imgUrl__2ox09Y img {\n  width: 30%;\n  height: 30%;\n  border-radius: 3px;\n}\n.PreviewDropzone__imgUrl__2ox09Y button {\n  margin: 0 auto;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"imgUrl": "PreviewDropzone__imgUrl__2ox09Y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/PreviewDropzone.styl
// module id = 3490
// module chunks = 39